import { IMAGES_NAMES } from '../constants';

const slidesConfig = {
    [IMAGES_NAMES.PIZZERIA]: {
        name: IMAGES_NAMES.PIZZERIA,
        seller: {
            username: 'titus_media',
            profileImage:
                'https://fiverr-res.cloudinary.com/t_profile_small,q_auto,f_auto/attachments/profile/photo/d3be0c74e67b5959dcb0749709ab59f3-1548431354321/dec43a8f-3e95-4529-84c5-c35f6960bcb5.jpg',
        },
        images: {
            sm: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a2ae16ab6258deb9e958ca0627e0e22-1604246691749/Pizza%20%28sm%29.png',
            md: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a2ae16ab6258deb9e958ca0627e0e22-1604246691771/Pizza%20%28md%29.png',
            lg: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a2ae16ab6258deb9e958ca0627e0e22-1604246691754/Pizza%20%28lg%29.png',
        },
    },
    [IMAGES_NAMES.BEAUTY]: {
        name: IMAGES_NAMES.BEAUTY,
        seller: {
            username: 'budaart',
            profileImage:
                'https://fiverr-res.cloudinary.com/t_profile_small,q_auto,f_auto/attachments/profile/photo/b7c6598c553c09455d31a72425d5dfe2-1569545409779/8c5cfce7-50b9-42d4-bbf6-23f5154b9b9d.jpg',
        },
        images: {
            sm: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/708154606cea112866bb876318aaa242-1604051617997/Beauty%20%28sm%29.png',
            md: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/708154606cea112866bb876318aaa242-1604051617984/Beauty%20%28md%29.png',
            lg: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/708154606cea112866bb876318aaa242-1604051617973/Beauty%20%28lg%29.png',
        },
    },
    [IMAGES_NAMES.REAL_ESTATE]: {
        name: IMAGES_NAMES.REAL_ESTATE,
        seller: {
            username: 'lironsho',
            profileImage:
                'https://fiverr-res.cloudinary.com/t_profile_small,q_auto,f_auto/attachments/profile/photo/e33a41ed6b3152710b1696f6edc0163c-1572949601299/1a2021fb-bf6d-41b2-aab5-0f52296f4dad.jpeg',
        },
        images: {
            sm: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/708154606cea112866bb876318aaa242-1604051617987/Real%20estate%20%28sm%29.png',
            md: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/708154606cea112866bb876318aaa242-1604051617974/Real%20estate%20%28md%29.png',
            lg: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/708154606cea112866bb876318aaa242-1604051617978/Real%20estate%20%28lg%29.png',
        },
    },
};

export default slidesConfig;
